import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { RevisorEditorRevistaDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class RevisorEditorRevistaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getRevisorEditorRevistaService(): Observable<BodyListResponse<RevisorEditorRevistaDTO>> {
    return this.http.get<BodyListResponse<RevisorEditorRevistaDTO>>(API_URL + '/api/v1/revisorEditorRevista/todos');
  }

  guardarRevisorEditorRevistaService(revisorEditorRevistaDTO: RevisorEditorRevistaDTO): Observable<RevisorEditorRevistaDTO> {
    return this.http.post<RevisorEditorRevistaDTO>(API_URL + '/api/v1/revisorEditorRevista', revisorEditorRevistaDTO);
  }

  getRevisorEditorRevistaPorCodigoRevisorEditorRevistaService(codigoRevisorEditorRevista: string): Observable<BodyResponse<RevisorEditorRevistaDTO>> {
    return this.http.get<BodyResponse<RevisorEditorRevistaDTO>>(API_URL + '/api/v1/revisorEditorRevista/' + codigoRevisorEditorRevista);
  }

  getRevisorEditorRevistaPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<RevisorEditorRevistaDTO>> {
    return this.http.get<BodyListResponse<RevisorEditorRevistaDTO>>(API_URL + '/api/v1/revisorEditorRevista/persona/' + codigoPersona);
  }
}
